import React from 'react';

import { useTranslation } from 'react-i18next';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { FavoritedUsersBlock } from '../../_blocks/FavoritedUsers';
import { Icons } from '../../components/atoms/SVG';
import { Namespace } from '../../translation/namespace';

export type FavoritedUsersWidget = WidgetShape<[FavoritedUsersBlock], WidgetType.favoritedusers>;

export function FavoritedUsersWidget({ blocks, elementType, ...headerProps }: FavoritedUsersWidget) {
  const { t } = useTranslation(Namespace.Widget);

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      title={t(`header.${elementType}`)}
      icon={Icons.CONTACTS_PHONEBOOK}
      widgetType={elementType}
      hierarchy={3}
    >
      <FavoritedUsersBlock {...blocks[0]} />
    </DefaultWidgetWithHeader>
  );
}
